import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';

type ThisApi = ApiDefinition['/credit-reports-b2c/{creditReportId}/permissions']['PUT'];
type Input = ThisApi['params'] & ThisApi['body'];

const updateCreditReportPermissions = async ({ creditReportId, userIds }: Input): Promise<ThisApi['response']> => {
  const response = await noodleApiClient.put(`/credit-reports-b2c/${creditReportId}/permissions`, { userIds });
  return response.data;
};

export default updateCreditReportPermissions;
